<template>
    <!-- Email Subscribe Section -->
    <div v-if="currentUser" id="section-newsletter" class="row section-style text-center">
        <email-subscribe-form :loading="loading" @submit="subscribe"></email-subscribe-form>
    </div>
</template>

<script>
    import EmailSubscribeForm from "./../forms/EmailSubscribeForm";
    import {mapGetters} from "vuex";
    import {HttpResponseStatus} from "./../../services/Http/HttpResponse";

    export default {
        components: {EmailSubscribeForm},
        created() {
            this.initialize();
        },

        computed: {
            ...mapGetters({
                currentUser: "Auth/user",
            }),
        },

        data() {
            return {
                email: "",
                loading: false,
            };
        },

        methods: {
            initialize() {
                this.$store.dispatch("Auth/fetchUser");
            },

            async subscribe(form) {
                if (this.loading) return;

                try {
                    this.loading = true;
                    let response = await this.$httpClient.request("post", "/api/actions/subscribe-email", form, true);

                    if(response.status === HttpResponseStatus.OK)
                    {
                        this.email = "";
                        this.$store.dispatch("Auth/fetchUser");
                    }
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    #section-newsletter {
        background: #495057;
    }

    div #section-newsletter, div #section-newsletter .inside-submit {
        background-color: #495057;
    }
</style>